import { Message } from "./../../../@types/message.d";
import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from "../../../utils/axiosConfig";

export const fetchDocumentHistory = createAsyncThunk(
  "documentSupervisorShow/fetchDocumentHistory",
  async (idDocument: string, { rejectWithValue, getState }) => {
    try {
      const params = {
        where: { room: idDocument },
        sort: "createdAt DESC",
      };

      const response = await axiosInstance.get(`${api.baseURL}message`, { params });

      const data: Message[] = response.data;

      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
